export type PreviewReturnTarget = 'main' | 'portal'

export type PreviewEntry =
  | { mode: 'standalone' }
  | { mode: 'preview'; code: string | null; returnTarget: PreviewReturnTarget | null }

const LAUNCH_CODE = /^[A-Za-z0-9_-]{43,128}$/
const RETURN_TARGET_PARAM = 'return_to'

export function getPreviewEntry(
  search: string,
  previewOnly: true,
): Extract<PreviewEntry, { mode: 'preview' }>
export function getPreviewEntry(search: string, previewOnly?: false): PreviewEntry
export function getPreviewEntry(search: string, previewOnly = false): PreviewEntry {
  const params = new URLSearchParams(search)
  if (!params.has('launch')) {
    return previewOnly
      ? { mode: 'preview', code: null, returnTarget: null }
      : { mode: 'standalone' }
  }
  const keys = [...params.keys()]
  const launches = params.getAll('launch')
  const returnTargets = params.getAll(RETURN_TARGET_PARAM)
  const allowedKeys = keys.every((key) => key === 'launch' || key === RETURN_TARGET_PARAM)
  const target = parseReturnTarget(returnTargets)
  const expectedKeyCount = returnTargets.length === 0 ? 1 : 2
  if (
    !allowedKeys
    || keys.length !== expectedKeyCount
    || launches.length !== 1
    || target === null
  ) {
    return { mode: 'preview', code: null, returnTarget: null }
  }
  const code = launches[0]
  const validCode = LAUNCH_CODE.test(code)
  return {
    mode: 'preview',
    code: validCode ? code : null,
    returnTarget: validCode ? target : null,
  }
}

function parseReturnTarget(values: string[]): PreviewReturnTarget | null {
  if (values.length === 0) return 'portal'
  if (values.length !== 1) return null
  return values[0] === 'main' || values[0] === 'portal' ? values[0] : null
}

export function clearLaunchFromHistory(
  location: Pick<Location, 'pathname' | 'hash'>,
  history: Pick<History, 'replaceState'>,
) {
  history.replaceState({}, '', `${location.pathname}${location.hash}`)
}
